// extracted by mini-css-extract-plugin
export default {"title-policy":"Policy_title-policy__MxcKs","terms-text":"Policy_terms-text__k6wfD"};